import { render } from "./ImpersonatePage.vue?vue&type=template&id=267c6e1e"
import script from "./ImpersonatePage.vue?vue&type=script&lang=js"
export * from "./ImpersonatePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__